import { apiResource } from '@/util/resources'

export default {
  state: {
    faqData: null
  },
  mutations: {
    setFaqCommit: (state, payload) => {
      state.faqData = payload
    }
  },
  actions: {
    getFaqData ({ state, commit }) {
      commit('setInitializing', true)
      return new Promise((resolve, reject) => {
        if (state.faqData == null) {
          apiResource.get('api/faq').then((response) => {
            commit('setFaqCommit', response.data)
            commit('setInitializing', false)
            resolve(response.data)
          }, error => {
            commit('setInitializing', false)
            reject(error)
          }
          )
        } else {
          commit('setInitializing', false)
          resolve(state.faqData)
        }
      })
    }
  },
  getters: {
    faqData (state) {
      return state.faqData
    }
  }
}
